import { branchConfig as ansan } from "./branches/ansan.js";
import { branchConfig as sadang } from "./branches/sadang.js";
import { branchConfig as bucheon } from "./branches/bucheon.js";
import { branchConfig as gwanggyo } from "./branches/gwanggyo.js";
import { branchConfig as geomdan } from "./branches/geomdan.js";

// 미정 TODO — 카카오 심사·외부 연동 완료 전 지점별 임시 정책.
const policies = new Map([[ansan.branchId, ansan], [bucheon.branchId, bucheon], [sadang.branchId, sadang], [geomdan.branchId, geomdan], [gwanggyo.branchId, gwanggyo]]);
export function integrationPolicy(siteId = process.env.NEXT_PUBLIC_BRANCH_ID) {
  return policies.get(siteId) ?? null;
}
